import React, { useEffect } from 'react';
import { Container, Row, Col, Button, Card, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import carImg from '../../../assets/travel.jpg';
import vanImg from '../../../assets/vans.jpg';
import busImg from '../../../assets/bus3.jpg';
import luxuryCarImg from '../../../assets/luxury.jpg';
import mapImg from '../../../assets/normal travel.jpg';

const TravelPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <div>
      <section className="travel-header py-5">
        <Container className="text-center">
          <h1 data-aos="fade-up">Explore India with SHIVEK TOURS AND TRAVELS</h1>
          <p data-aos="fade-up" data-aos-delay="200">
            Let your journey begin with us. Comfort, safety, and the best vehicles await you!
          </p>
            <Button variant="primary" href='#ride' size="lg" data-aos="fade-up" data-aos-delay="400">
              Book Your Trip
            </Button>
        </Container>
      </section>

      <section className="company-overview py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="d-flex justify-content-center" data-aos="fade-left">
              <img src={mapImg} alt="Travel" className="img-fluid rounded" />
            </Col>
            <Col md={6} className="text-center text-md-left " data-aos="fade-right">
              <h2>Company Overview</h2>
              <p  style={{textAlign:'justify'}}>
              SHIVEK TOURS AND TRAVELS is your trusted partner for travel and vehicle services across PAN India. We pride ourselves on offering a wide range of vehicles, from cars to buses, to suit your travel needs at affordable prices. With years of experience in the travel industry, we aim to provide comfort, safety, and flexibility for all types of travelers, whether for corporate tours, family trips, or group travel.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="services py-5 bg-light">
        <Container>
          <h2 className="text-center mb-4" data-aos="fade-up">Our Services</h2>
          <Carousel controls={false} indicators={false}>
            <Carousel.Item>
              <Row className="text-center">
                <Col md={3} data-aos="fade-up">
                  <Card className="service-card">
                    <Card.Img variant="top" src={carImg} style={{height:'10rem'}}/>
                    <Card.Body>
                      <Card.Title>Cars</Card.Title>
                      <Card.Text>
                      (Sedans, Hatchbacks, SUVs) For individual travellers or small groups.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3} data-aos="fade-up" data-aos-delay="200">
                  <Card className="service-card">
                    <Card.Img variant="top" src={vanImg} style={{height:'10rem'}}/>
                    <Card.Body>
                      <Card.Title>Vans</Card.Title>
                      <Card.Text>
                      (7-24 seater) Ideal for family trips or small outings.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3} data-aos="fade-up" data-aos-delay="400">
                  <Card className="service-card">
                    <Card.Img variant="top" src={busImg} />
                    <Card.Body>
                      <Card.Title>Buses</Card.Title>
                      <Card.Text>
                      (20-50 seater) for group travel or corporate events.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3} data-aos="fade-up" data-aos-delay="600">
                  <Card className="service-card">
                    <Card.Img variant="top" src={luxuryCarImg} />
                    <Card.Body>
                      <Card.Title>Luxury Cars</Card.Title>
                      <Card.Text>
                      (Innova, Mercedes, Audi, BMW, etc.) for corporate clients tourists.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Carousel.Item>
          </Carousel>
        </Container>
      </section>

      <section className="testimonials py-5">
        <Container>
          <h2 className="text-center mb-4" data-aos="fade-up">What Our Clients Say</h2>
          <Row>
            <Col md={6} data-aos="fade-up">
              <blockquote>
                <p>"SHIVEK TOURS AND TRAVELS made our trip to Delhi so much more comfortable. The driver was excellent, and the car was top-notch. Highly recommended!"</p>
                <footer>- Rajesh Kumar</footer>
              </blockquote>
            </Col>
            <Col md={6} data-aos="fade-up" data-aos-delay="200">
              <blockquote>
                <p>"Excellent services and a great variety of vehicles. We had a hassle-free experience with 
                  SHIVEK TOURS AND TRAVELS!"</p>
                <footer>- Neha Verma</footer>
              </blockquote>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="contact py-5 bg-light" id='ride'>
        <Container>
          <h2 className="text-center mb-4" data-aos="fade-up">Get in Touch</h2>
          <Row className= "justify-content-center">
            <Col md={6} data-aos="fade-up" data-aos-delay="200">
            <Card className="shadow-lg">
                <Card.Body className="text-center">
                  <Card.Title as="h4">Contact Information</Card.Title>
                  <Card.Text className="mb-4">
                    If you have any questions contact us!
                  </Card.Text>
                  <ul className="list-unstyled">
                    <li><strong>Email:</strong> shiveke@gmail.com</li>
                    <li><strong>Phone:</strong> 9424809020 </li>
                  </ul>
                    <Link to='/contact'>
                  <Button variant="primary" >
                    Contact Us
                  </Button>
                    </Link>
                </Card.Body>
              </Card>
            </Col>
            
          </Row>
        </Container>
      </section>

    
    </div>
  );
};

export default TravelPage;
